import { Professional, Team } from "@syadem/ariane-js";
import { Daphne } from "@syadem/daphne-js";
import { VaccinationAct as ProVaccinationAct } from "@syadem/kairos-pro-js";
import { VaccinationAct as TeamVaccinationAct } from "@syadem/kairos-team-js";
import { DomainHealthRecord } from "../../domain/healthRecord";
import { VaccinationActListItem } from "./VaccinationActListItem";

function VaccinationActsByList({
  certificators,
  sortedVaccinationActs,
  healthRecord,
  daphne,
  showActions = true,
}: {
  certificators: (Professional | Team)[];
  sortedVaccinationActs: ProVaccinationAct[] | TeamVaccinationAct[];
  healthRecord: DomainHealthRecord;
  daphne: Daphne;
  showActions?: boolean;
}) {
  return sortedVaccinationActs.map((vaccinationAct) => (
    <VaccinationActListItem
      vaccinationAct={vaccinationAct}
      healthRecord={healthRecord}
      showActions={showActions}
      key={vaccinationAct.id}
      daphne={daphne}
      certificators={certificators}
    />
  ));
}

export default VaccinationActsByList;
